// extracted by mini-css-extract-plugin
export default {"textBox":"input_textBox__Uk6g3"};